/**
 * UC1 "Key indicators" (NOTES #729): the five constraints, what each one measures, the data
 * behind it and when it is flagged — a plain list for management, no numbers. A watershed
 * clicked on the map still shows its own scorecard underneath (`SelectedArea`).
 */
import { useTranslation } from 'react-i18next';

import { CONSTRAINT_COLORS, NEUTRAL_COLOR, UC1_DIMENSIONS } from './uc1Constants';

export function IndicatorsUsed() {
  const { t } = useTranslation();
  return (
    <div id="uc1Indicators" className="result-box">
      <h5>{t('intel.uc1.indicators.title')}</h5>
      <div className="result-pad">
        <ul className="uc1-essence">
          {UC1_DIMENSIONS.map((dim) => (
            <li key={dim} data-testid={`uc1-indicator-${dim}`} style={{ borderLeft: `3px solid ${CONSTRAINT_COLORS[dim] ?? NEUTRAL_COLOR}`, paddingLeft: 8 }}>
              <b>{t(`intel.uc1.dimension.${dim}`)}</b>
              <span>{t(`intel.uc1.essence.${dim}.what`)}</span>
              <span className="sub">{t(`intel.uc1.essence.${dim}.rule`)}</span>
            </li>
          ))}
        </ul>
        <p className="sub">{t('intel.uc1.indicators.foot')}</p>
      </div>
    </div>
  );
}

export default IndicatorsUsed;
